import React from "react";
import { Button } from "react-bootstrap";
import { FilterX } from "lucide-react";
import { seguimientoStatuses } from "./seguimientoFilterRules";

export default function SeguimientoFilters({ value, onChange }) {
  const active = value.interviews || value.schedule || value.statuses.length;
  return (
    <details
      className="surface seguimiento-filters"
      aria-label="Filtros de seguimientos"
    >
      <summary className="seguimiento-filters-summary fw-semibold">Filtros de seguimientos{active ? " · Activos" : ""}</summary>
      <div className="followup-primary-filters">
        <div className="seguimiento-filter-group">
          <span className="filter-group-label">Tipo de seguimiento</span>
          <div className="filter-chips">
            <Button
              variant="light"
              className="filter-chip chip-interviews"
              aria-pressed={value.interviews}
              onClick={() =>
                onChange({ ...value, interviews: !value.interviews })
              }
            >
              Entrevistas
            </Button>
          </div>
        </div>
        <div className="seguimiento-filter-group">
          <span className="filter-group-label">Seguimientos programados</span>
          <div className="filter-chips">
            {[
              ["vigentes", "Vigentes"],
              ["porVencer", "Por vencer"],
              ["vencidos", "Vencidos"],
            ].map(([key, label]) => (
              <Button
                key={key}
                variant="light"
                className={`filter-chip chip-${key}`}
                aria-pressed={value.schedule === key}
                onClick={() =>
                  onChange({
                    ...value,
                    schedule: value.schedule === key ? "" : key,
                  })
                }
              >
                {label}
              </Button>
            ))}
          </div>
        </div>
      </div>
      <div className="seguimiento-filter-group status-filter-group">
        <span className="filter-group-label">Estatus del seguimiento</span>
        <div className="filter-chips">
          {seguimientoStatuses.map(([key, label]) => (
            <Button
              key={key}
              title={key}
              variant="light"
              className={`filter-chip ${key === "Ganado" ? "chip-won" : key === "Perdido" ? "chip-lost" : ""}`}
              aria-label={key}
              aria-pressed={value.statuses.includes(key)}
              onClick={() =>
                onChange({
                  ...value,
                  statuses: value.statuses.includes(key)
                    ? value.statuses.filter((s) => s !== key)
                    : [...value.statuses, key],
                })
              }
            >
              {label}
            </Button>
          ))}
        </div>
      </div>
      <footer className="followup-filter-footer">
        <small>
          {active
            ? "Los filtros se combinan; puedes elegir varios estatus."
            : "Seguimientos abiertos (sin ganados ni perdidos)."}{" "}
          Por vencer: próximos 2 días.
        </small>
        <Button
          variant="link"
          className="clear-followup-filters"
          disabled={!active}
          onClick={() =>
            onChange({ schedule: "", statuses: [], interviews: false })
          }
        >
          <FilterX size={16} />
          Limpiar filtros
        </Button>
      </footer>
    </details>
  );
}
